import { render } from "./FullReportTable.vue?vue&type=template&id=5855c9e4"
import script from "./FullReportTable.vue?vue&type=script&lang=js"
export * from "./FullReportTable.vue?vue&type=script&lang=js"

import "./FullReportTable.vue?vue&type=style&index=0&id=5855c9e4&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__